import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrewTranslocoHttpLoader implements TranslocoLoader {
  private http: HttpClient = inject(HttpClient);

  /**
   * Loads translation files. Handles both global and scoped paths.
   * Global: lang = 'no' → /assets/i18n/no.json
   * Scoped: lang = 'sidebar/no' → /assets/i18n/sidebar/no.json
   */
  getTranslation(lang: string): Observable<Translation> {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
